const parentIdOf = (option) => option?.parent_option || option?.parent_option_id || null;

const childParentId = (row) => row?.parent_option || row?.parent_option_id || null;

export const isCreatedOnLocalDay = (created, now = new Date()) => {
  if (!created) return false;
  const createdDate = new Date(created);
  if (Number.isNaN(createdDate.getTime())) return false;
  return createdDate.getFullYear() === now.getFullYear()
    && createdDate.getMonth() === now.getMonth()
    && createdDate.getDate() === now.getDate();
};

export const getOptionEditLock = (option, allOptions = [], now = new Date()) => {
  const id = Number(option?.id);
  const hasChildren = allOptions.some((row) => Number(childParentId(row)) === id && id > 0);
  const parentId = parentIdOf(option);
  if (hasChildren) {
    return { structuralLocked: true, canDelete: false, reason: "original" };
  }
  if (parentId && !isCreatedOnLocalDay(option?.created, now)) {
    return { structuralLocked: true, canDelete: false, reason: "bookkeeping" };
  }
  if (parentId) {
    return { structuralLocked: false, canDelete: true, reason: "same_day" };
  }
  return { structuralLocked: false, canDelete: true, reason: null };
};

export const shouldRevertParentAfterDelete = (deletedOption, allOptions = []) => {
  const parentId = parentIdOf(deletedOption);
  if (!parentId) return false;
  const siblings = allOptions.filter((row) => (
    Number(childParentId(row)) === Number(parentId) && Number(row?.id) !== Number(deletedOption?.id)
  ));
  return siblings.length === 0;
};
